import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=c295a5c4&scoped=true&"
import script from "./back-top.vue?vue&type=script&lang=js&"
export * from "./back-top.vue?vue&type=script&lang=js&"
import style0 from "./back-top.vue?vue&type=style&index=0&id=c295a5c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c295a5c4",
  null
  
)

export default component.exports